// Auto-refactored from translations.js on 2026-08-19
// Locale: ar

const ar = {
  wieMoeglich: { question: 'كيف يكون ذلك ممكنًا؟', answer: 'لقد أعدنا التفكير في سلسلة القيمة.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'طريق STIG ROCK',
    fazit: 'سلسلة التوريد المختصرة تُلغي أكبر بنود التكلفة.',
    fazitBigPre: 'وهذا يتيح خصمًا يصل إلى',
    fazitBigValue: '80%',
    steps: [ 'المنجم', 'ورشة القطع', 'الشهادة', 'العميل النهائي' ]
  },
  nav: { language: 'اللغة', contact: 'اتصل بنا' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'فرصة فريدة من نوعها',
    subtitle: 'بناء الثروة برؤية مستقبلية.',
    description: 'STIG ROCK هي منصة عالمية توفر للأفراد إمكانية الوصول إلى الماس الطبيعي، وبناء ثروة مستدامة، ومجتمع فريد من نوعه.',
    scroll: 'مرر للاكتشاف'
  },
  disclaimer: {
    overline: 'إشعار قانوني',
    title: 'Disclaimer',
    paragraphs: [
      'هذا العرض التقديمي مخصص للأغراض المعلوماتية فقط ولا يشكل استشارة مالية أو استثمارية أو ضريبية.',
      'STIG ROCK ليس منتجاً مالياً، بل يتعلق بـ Diamond الطبيعي كأصول ملموسة.',
      'لا يوجد ضمان لتطور القيمة أو الأرباح أو العوائد. التطورات السابقة ليست مؤشراً على النتائج المستقبلية.',
      'جميع الحسابات المعروضة المتعلقة بالعمولات هي مجرد أمثلة ولا تمثل ضماناً أيضاً.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'بناء القيمة', 'على هيكل متين' ],
    body: 'STIG Group هي تكتل دولي مبني على الوضوح والمسؤولية والقيمة طويلة الأمد. كل علامة تجارية وكل مشروع وكل Partner يتبع معياراً واحداً — بلا اختصارات وبلا استثناءات.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'بناء القيمة', 'على هيكل متين' ],
        body: 'STIG Group هي تكتل دولي مبني على الوضوح والمسؤولية والقيمة طويلة الأمد. كل علامة تجارية وكل مشروع وكل Partner يتبع معياراً واحداً — بلا اختصارات وبلا استثناءات.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'عالم من الـ', 'Diamond الحصري' ],
        body: 'STIG ROCK هو مفهوم حديث من STIG Group يجمع بين Diamond عالي الجودة المعتمد من GIA وبين الهياكل الشفافة وتجربة العملاء الحصرية. خطط حلول واضحة، تنفيذ احترافي وتوجه دولي.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'تجارة الـ Diamond', 'الدولية' ],
        body: 'Stig International هي جزء من STIG Group ومتخصصة في التجارة الدولية لـ Diamond المعتمد من GIA. التركيز على الجودة والثقة وهياكل التجارة الحديثة مع شراكات عالمية.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'المسؤولية', 'من المنجم' ],
        body: 'تمثل ETHICAL MINES التعدين المسؤول، والمصدر القابل للتتبع، و Diamond الخالي من الصراعات. من المنجم إلى السوق — توثيق كامل للشفافية والنزاهة والمسؤولية طويلة الأمد عبر سلسلة التوريد.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'الألماس',
    stigDrawback: 'مخزن حقيقي للقيمة',
    overline: 'الفرص',
    title: 'فرص بناء الثروة',
    subtitle: 'مقارنة مع الطرق التقليدية.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex أو Krypto',
        drawback: 'مضاربة عالية، لا يمكن التنبؤ بها، معقدة'
      },
      {
        tag: 'الأسهم',
        name: 'تداول البورصة',
        drawback: 'مخاطر التقلب، المعرفة المطلوبة، استهلاك الوقت'
      },
      { tag: 'Krypto', name: 'تداول', drawback: 'التذبذب، مخاطر التنظيم، الثغرات الأمنية' }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: 'الفرصة المستخف بها',
    body: 'يعد Diamond منذ سنوات من أكثر أشكال الاستثمار استقراراً في القيمة ومليئة بالفرص، ولكن حتى الآن لم يستغل هذه الإمكانات إلا القليل.',
    callout: 'مع STIG ROCK، نفتح لأول مرة الوصول إلى هذه الفرص الاستثنائية للجميع.'
  },
  wertentwicklung: {
    overline: 'تطور القيمة 1995 — 2025',
    title: 'قصة عن القيمة.',
    usd: 'دولار أمريكي',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: 'التطور منذ 1995 — 2025'
  },
  hauptgruende: {
    overline: 'الأسباب الرئيسية',
    title: 'ستة أسباب لـ Diamond',
    lead: 'Diamond هو أصل ملموس حقيقي، يظل مستقلاً عن العملات والأنظمة المالية — ويحافظ على قيمته منذ قرون.',
    items: [
      {
        n: '01',
        title: 'استقرار القيمة المقاوم للأزمات',
        body: 'ضمان الأصول الملموسة. مستقل عن العملات والأنظمة المالية.'
      },
      { n: '02', title: 'الحركية المطلقة', body: 'صغير، سهل الإخفاء والنقل.' },
      { n: '03', title: 'التنويع والندرة', body: 'نقص المعروض والقيود الطبيعية.' },
      { n: '04', title: 'نمو طويل الأمد', body: '+185% منذ عام 1995.' },
      {
        n: '05',
        title: 'الشفافية والحصرية',
        body: 'معايير 4 Cʼs كضمان: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'احتياطي العائلات الملكية',
        body: 'حتى العائلات الملكية تستخدم Diamond كاحتياطي للثروة.'
      }
    ]
  },
  markt: {
    overline: 'حجم السوق',
    title: '99 — 108 Mrd. USD',
    sub: 'حجم التداول في عام 2025',
    forecast: 'التوقعات حتى ~2032 / 2034: حوالي 140 – 168 Mrd. USD مع نمو معتدل (~4 – 5 % p.a.).',
    source: 'المصدر: Fortune Business Insights'
  },
  innovation: {
    overline: 'STIG INTERNATIONAL — الابتكار',
    title: 'ابتكار. لأول مرة على مستوى العالم.',
    body: 'STIG ROCK هي المنصة الأولى عالمياً التي تتيح للأفراد تحقيق دخل سلبي في سوق Diamond بالإضافة إلى زيادة القيمة.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'رقم السجل DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'عن الشركة',
    titleLines: [ 'هيكل دولي', 'رؤية واضحة' ],
    body: 'تأسست STIG ROCK لجعل سوق Diamond أكثر شفافية وحداثة وتركيزاً على العملاء — مع التركيز على الثقة والأمان والهيكل طويل الأمد.'
  },
  sicherheit: {
    overline: 'الجودة والأمان',
    title: 'Gemological Institute of America',
    body: 'خبرة معتمدة لـ Diamond الخاص بك. يقوم GIA بتقييم كل حجر بأقصى درجات الدقة والخبرة الطويلة — تقارير تقييم موثوقة لشركتنا وعملائنا.',
    transparency: 'كل حجر Diamond يلبي أعلى معايير الجودة ويتم فحصه واعتماده من قبل منظمات مرموقة. كل حجر فريد ويحصل على شهادة فردية.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'ابتكار منتج فريد',
    sub: 'ستة Solution Pläne متدرجة — من $1K إلى +$100K، مع خصم متزايد شهرياً وعبر كامل المدة.',
    recommended: 'الأكثر طلباً',
    oneYear: '1 سنة',
    rowLabels: {
      delivery: 'وقت التسليم',
      price: 'سعر المنتج',
      carat: 'Karat',
      monthly: 'خصم (شهري)',
      totalDiscount: 'إجمالي الخصم',
      duration: 'المدة'
    },
    headers: {
      plan: 'الخطة',
      from: 'من',
      carat: 'Karat',
      monthly: 'خصم / شهر',
      total: 'إجمالي الخصم',
      duration: 'المدة'
    },
    duration: '1 سنة',
    footnote: 'جميع تفاصيل الأسعار قابلة للتغيير وتعتمد على الجودة والطلب وتطور السوق الحالي. خطط Solution ممكنة أيضاً لمدة سنتين.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + باقة VIP',
    title: 'المزيد من المزايا مع VIP-Paket',
    sub: 'اجمع بين Solution Plan الخاص بك وباقة VIP-Paket واستفد من مزايا سعرية إضافية تصل إلى 3%. وبذلك تزيد من إجمالي الخصم الخاص بك وتحصل على شروط أكثر جاذبية.',
    rowLabels: {
      delivery: 'وقت التسليم',
      price: 'سعر المنتج',
      carat: 'Karat',
      monthly: 'خصم (شهري)',
      totalDiscount: 'إجمالي الخصم',
      vip1: 'باقة VIP 1 (+1%)',
      vip2: 'باقة VIP 2 (+2%)',
      vip3: 'باقة VIP 3 (+3%)'
    },
    footnote: 'جميع تفاصيل الأسعار قابلة للتغيير وتعتمد على الجودة والطلب وتطور السوق الحالي.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'المزيد من المزايا مع VIP-Paket',
    sub: 'اجمع بين Solution Plan الخاص بك وباقة VIP-Paket واستفد من مزايا سعرية إضافية تصل إلى 3%. وبذلك تزيد من إجمالي الخصم الخاص بك وتحصل على شروط أكثر جاذبية.',
    options: [
      {
        key: 'deliver',
        title: 'المزيد من المزايا مع VIP-Paket',
        body: 'Diamond (Karat) بسعر DS-Plan* الخاص بك'
      },
      {
        key: 'sellToUs',
        title: 'البيع لنا',
        body: 'يمكنك إعادة بيع Diamond لنا بسعر الشراء الذي دفعته.'
      },
      {
        key: 'sellThirdParty',
        title: 'البيع لأطراف ثالثة',
        body: 'يمكنك إعادة بيع Diamond لأطراف ثالثة.'
      }
    ],
    footnote: '*DS-Plan يشير إلى خطة Solution.'
  },
  tradWeg: {
    overline: 'التجارة التقليدية',
    title: 'الطريقة التقليدية',
    sub: 'قبل أن يصل Diamond إلى العميل النهائي، تنشأ هوامش ربح تجارية كبيرة من خلال تجارة الوساطة والجملة والتجزئة مقارنة بسعر Diamond الخام من المنجم.',
    steps: [
      { title: 'المنجم', subtitle: 'Diamond خام' },
      { title: 'الوسطاء', subtitle: 'شراء Diamond خام' },
      { title: 'المصقلة', subtitle: 'صقل لإنتاج Diamond مجوهرات' },
      { title: 'الشهادة', subtitle: 'من خلال معاهد معتمدة مثل GIA' },
      { title: 'بورصة Diamond', subtitle: 'البيع لتجار الجملة' },
      { title: 'تجارة الجملة', subtitle: 'البيع لتجار التجزئة' },
      { title: 'تجارة التجزئة', subtitle: 'مثل متاجر المجوهرات' },
      { title: 'العملاء النهائيون', subtitle: 'شراء Diamond' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'باقات VIP',
    sub: 'صالحة لمدة 12 شهراً على جميع خطط Solution التي توقعها. حسب باقة VIP: خصم إضافي من +1% إلى +3%',
    cardKicker: 'إضافي – على جميع',
    cardKicker2: 'خطط Solution',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'الخصومات تتحول إلى مدخرات',
      body: 'توفير شهري بدلاً من عبء شهري. الخصومات تخلق مدخرات — وهذه المدخرات تدفع بالضبط الأشياء التي تدفعها عادة كل شهر من جيبك الخاص.',
      line1Label: 'DS-Plan من',
      line1Value: '$5.000',
      line2Label: 'الخصم الشهري',
      line2Value: '3%',
      line3Label: 'باقة VIP 3',
      line3Value: '+3%',
      resultLabel: 'المدخرات الشهرية',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'كيف يكون ذلك ممكناً؟',
    title: 'لقد أعدنا التفكير في سلسلة القيمة.',
    traditionalTitle: 'الطريقة التقليدية',
    traditionalSteps: [
      'المنجم — Diamond خام',
      'الوسطاء — الشراء',
      'المصقلة — الصقل',
      'الاعتماد (GIA)',
      'بورصة Diamond — تجارة الجملة',
      'تجارة الجملة ← تجارة التجزئة',
      'المجوهرات ← العميل النهائي'
    ],
    traditionalNote: 'قبل أن يصل Diamond إلى العميل النهائي، تنشأ هوامش ربح تجارية كبيرة من خلال تجارة الوساطة والجملة والتجزئة.',
    stigTitle: 'طريقة STIG ROCK',
    stigSteps: [
      'شراء مباشر — Diamond خام من المنجم',
      'الصقل والاعتماد من قبل شركائنا',
      'البيع للعملاء النهائيين وعملاء B2B',
      'ما يصل إلى 4 دورات تجارية في السنة'
    ],
    stigNote: 'نحن نكسر الدائرة ونمرر هوامش الربح كخصومات لعملائنا — ما يصل إلى 4 دورات تجارية خلال مدة DS-Plan.'
  },
  optionen: {
    overline: 'خياراتك',
    title: 'بعد انتهاء خطة Solution الخاصة بك',
    items: [
      { title: 'طلب التسليم', body: 'Diamond (Karat) بسعر خطة DS-Plan الخاصة بك.' },
      { title: 'البيع لنا', body: 'إعادة البيع بسعر الشراء الذي دفعته.' },
      { title: 'البيع لأطراف ثالثة', body: 'بيع Diamond في السوق الحرة.' }
    ]
  },
  einfacherWeg: {
    overline: 'خطط Solution — ابتكار منتج فريد',
    title: 'الطريق البسيط',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'التسجيل',
        body: 'تواصل مع الموصي بك وأنشئ حساباً مجانياً!'
      },
      { n: '02', icon: 'cart', title: 'شراء منتج', body: 'بدءاً من $ 250,- فقط' },
      {
        n: '03',
        icon: 'discount',
        title: 'الحصول على خصومات',
        body: 'احصل على خصومات شهرية.'
      }
    ]
  },
  business: {
    overline: 'أنواع البونص',
    title: 'الطريقة الأبسط والأكثر عدلاً.',
    sub: 'خمسة أنواع من البونص — لبناء عملك بنجاح.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'حتى المستوى 3، بدءاً من رتبة Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'بدءاً من Sapphire — لعمق غير محدود.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'على Infinity Bonus – حتى المستوى 5 · بدون شروط تأهيل.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 أحواض من المبيعات العالمية.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'بونص لمرة واحدة في شكل Diamond (Karat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'يتم دفع هذا البونص لك عن كل خطة Solution جديدة يتم توقيعها حتى المستوى الثالث. تفتح المستويات الفردية بمؤهلات بسيطة جداً.',
    total: 'ما يصل إلى 18% Unilevel Bonus',
    levels: [
      {
        level: 'المستوى 1',
        value: '10%',
        qual: 'من البداية',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'المستوى 2',
        value: '5%',
        qual: 'بدءاً من رتبة Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'المستوى 3',
        value: '3%',
        qual: 'بدءاً من رتبة Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'بدءاً من رتبة Sapphire تكون مؤهلاً لخطة Infinity Bonus الخاصة بنا. تحصل على 3% بونص. مع كل مستوى مهني جديد، تضاف نسب مئوية أخرى. إذا كان شريك في فريقك مؤهلاً أيضاً، فستحصل على الفرق بين الرتبتين.',
    exampleTitle: 'مثال',
    exampleRows: [
      { label: 'أنت برتبة Blue Diamond', value: '12%' },
      { label: 'شريكك برتبة Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Infinity Bonus الخاص بك', value: '9%' },
    totalNote: 'إجمالي يصل إلى 24% Infinity Bonus على جميع خطط Solution الموقعة في فريقك — لعمق غير محدود.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'مع هذا البونص ستستفيد من نجاح فريقك. تحصل على Matching Bonus بنسبة 5% على Infinity Bonus لشركائك — وحتى المستوى الخامس في فريقك.',
    note: 'على جميع مدفوعات Infinity Bonus في فريقك – حتى المستوى الخامس. من البداية – بدون شروط تأهيل.',
    levels: [
      { level: 'المستوى 1', value: '5%' },
      { level: 'المستوى 2', value: '5%' },
      { level: 'المستوى 3', value: '5%' },
      { level: 'المستوى 4', value: '5%' },
      { level: 'المستوى 5', value: '5%' }
    ],
    totalPrefix: 'إجمالي يصل إلى',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% من المبيعات العالمية تذهب بأجزاء متساوية إلى 3 أحواض مختلفة. من خلال الوصول إلى رتب مهنية معينة، تتأهل لكل حوض بشكل منفرد.',
    forever: 'بمجرد الوصول إليها – مشاركة للأبد!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'بدءاً من Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'بدءاً من Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'بدءاً من Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'إجمالي',
    totalValue: '3%',
    totalSuffix: 'من المبيعات العالمية'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'بدءاً من رتبة Diamond ستحصل على Rang Bonus. يتم دفع هذا البونص في شكل Diamond (Karat). هذا البونص يدفع لمرة واحدة.',
    highlight: 'Diamond (Karat) بقيمة إجمالية قدرها',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · الرتب المهنية',
    title: 'الرتب المهنية',
    sub: 'للوصول إلى الرتب المهنية المعنية، يتم احتساب إجمالي المبيعات التاريخية (HG). ويجب أن يكون هذا المجموع موزعاً على عدة فرق بدءاً من رتبة Sapphire. للوصول إلى Ruby أو أعلى، تحتاج إلى شريكين مباشرين على الأقل يمتلك كل منهما خطة Solution.',
    forever: 'بمجرد الوصول إليها – مؤكدة للأبد!',
    footnote: 'HV = إجمالي المبيعات التاريخية.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 شركاء مباشرين', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'انطلق معنا',
    title: 'الوقت المناسب هو الآن.',
    body: 'يضع نموذج العمل هذا معايير جديدة ويجمع كل عوامل النجاح لعمل مستدام وناجح على المدى الطويل. سجل اليوم، واختر خطة Solution الخاصة بك واستفد من هذه الفرصة التجارية الفريدة.',
    hint: 'تحدث مع الشخص الذي دعاك إلى هذا العرض التقديمي — لديه رابط تسجيل لك.',
    formName: 'الاسم',
    formEmail: 'البريد الإلكتروني',
    formPhone: 'الهاتف',
    formSubmit: 'تواصل معنا',
    success: 'شكراً جزيلاً — سنرد عليك بشكل شخصي وسري.',
    callCta: 'اتصال',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'إشعار قانوني و Disclaimer',
    disclaimer: 'هذا العرض التقديمي مخصص للأغراض المعلوماتية فقط ولا يشكل استشارة مالية أو استثمارية أو ضريبية. STIG ROCK ليس منتجاً مالياً، بل يتعلق بـ Diamond الطبيعي كأصول ملموسة. لا يوجد ضمان لتطور القيمة أو الأرباح أو العوائد. التطورات السابقة ليست مؤشراً على النتائج المستقبلية. جميع الحسابات المعروضة المتعلقة بالعمولات هي مجرد أمثلة ولا تمثل ضماناً أيضاً. المحتويات قابلة للتغيير — ترجمة حرة (ليست ترجمة رسمية).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. جميع الحقوق محفوظة.',
    version: 'الإصدار: DS-12-2025 V3'
  },
  misc: { next: 'القسم التالي' }
};

export default ar;
